import { render, staticRenderFns } from "./InstagramComponent.vue?vue&type=template&id=47d83b3c&scoped=true&v-if=widgetType%20%3D%3D%3D%20'Instagram'&"
import script from "./InstagramComponent.vue?vue&type=script&lang=js&"
export * from "./InstagramComponent.vue?vue&type=script&lang=js&"
import style0 from "./InstagramComponent.vue?vue&type=style&index=0&id=47d83b3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d83b3c",
  null
  
)

export default component.exports